import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import useLogic from "./logic/useLogic";
import EditorSuit from "./components/EditorSuit";

const ImageEdtior = ({
  editPictureBtnText,
  disabled,
  content,
  setOnFileContentChanges,
}) => {
  const {
    enableImageEditor,
    HandleEditBtnClick,
    setEnableImageEditor,
    enableEditor,
  } = useLogic(content);

  return (
    <React.Fragment>
      {enableEditor ? (
        <Button
          endIcon={<Edit />}
          sx={{ mt: ".3em", gap: "1em" }}
          variant="outlined"
          disabled={disabled}
          onClick={HandleEditBtnClick}
          fullWidth
        >
          {editPictureBtnText}
        </Button>
      ) : (
        <></>
      )}
      {enableImageEditor && content?.fileContent ? (
        <EditorSuit
          file={content}
          setEnableImageEditor={setEnableImageEditor}
          setOnFileContentChanges={setOnFileContentChanges}
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default ImageEdtior;
